import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import AgeGate from './components/AgeGate';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ShopPage from './pages/ShopPage';
import ProductDetailPage from './pages/ProductDetailPage';
import { BuildBoxPage, CartPage, LabResultsPage, AboutPage } from './pages/OtherPages';
import { DrinksPage, GummiesPage, FlowerPage, VapesPage, BundlesPage } from './pages/CategoryPages';
import CheckoutPage from './pages/CheckoutPage';
import OrderConfirmationPage from './pages/OrderConfirmationPage';
import { LoginPage, RegisterPage } from './pages/AuthPages';
import AccountPage from './pages/AccountPage';
import { SettingsProvider } from './context/SettingsContext';
import { ProductsProvider } from './context/ProductsContext';
import { CartProvider, useCart } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import './App.css';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function AppInner() {
  const { items, addToCart, updateQty, removeFromCart, count } = useCart();

  return (
    <>
      <AgeGate onVerify={() => {}} />
      <ScrollToTop />
      <Navbar cartCount={count} />
      <main>
        <Routes>
          <Route path="/" element={<HomePage onAddToCart={addToCart} />} />
          <Route path="/shop" element={<ShopPage onAddToCart={addToCart} />} />
          <Route path="/product/:id" element={<ProductDetailPage onAddToCart={addToCart} />} />
          <Route path="/build-box" element={<BuildBoxPage onAddToCart={addToCart} />} />
          <Route
            path="/cart"
            element={<CartPage cartItems={items} onUpdateQty={updateQty} onRemove={removeFromCart} />}
          />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/order/:id" element={<OrderConfirmationPage />} />
          <Route path="/lab-results" element={<LabResultsPage />} />
          <Route path="/about" element={<AboutPage />} />

          {/* Auth + account */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/account" element={<AccountPage />} />

          {/* Category pages */}
          <Route path="/shop/drinks" element={<DrinksPage onAddToCart={addToCart} />} />
          <Route path="/shop/gummies" element={<GummiesPage onAddToCart={addToCart} />} />
          <Route path="/shop/flower" element={<FlowerPage onAddToCart={addToCart} />} />
          <Route path="/shop/vapes" element={<VapesPage onAddToCart={addToCart} />} />
          <Route path="/shop/bundles" element={<BundlesPage onAddToCart={addToCart} />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <SettingsProvider>
      <ProductsProvider>
        <AuthProvider>
          <CartProvider>
            <Router>
              <AppInner />
            </Router>
          </CartProvider>
        </AuthProvider>
      </ProductsProvider>
    </SettingsProvider>
  );
}

export default App;
